import type React from "react";
import { SurveyEditor } from "@/components/SurveyEditor";
import { useFolderId } from "@/hooks/useFolderId";

export const NewSurvey: React.FC = () => {
  const folderId = useFolderId();

  return <SurveyEditor isCreating={true} folderIdParam={folderId} />;
};
